import { defineComponent as w, mergeModels as k, useModel as W, getCurrentInstance as N, useTemplateRef as P, computed as R, watch as S, createBlock as y, openBlock as r, resolveDynamicComponent as B, mergeProps as v, unref as l, withCtx as s, createVNode as g, createElementBlock as m, createCommentVNode as i, createElementVNode as T, normalizeClass as n, renderSlot as c, createTextVNode as f, toDisplayString as b, useId as D } from "vue";
import o from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Check/check.js";
import { useOUIAProps as L } from "../helpers/ouia.js";
import M from "../helpers/Sort.vue2.js";
import A from "../helpers/SortBy.vue2.js";
import { useChildrenTracker as E } from "../use/children-tracker.js";
import { FormInputsKey as z } from "./Form/common.js";
const F = ["id", "checked", "disabled", "required"], X = /* @__PURE__ */ w({
  name: "PfCheckbox",
  inheritAttrs: !1,
  __name: "Checkbox",
  props: /* @__PURE__ */ k({
    component: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    id: { default: () => D() },
    label: {},
    body: {},
    description: {},
    labelWrapped: { type: Boolean },
    labelBeforeButton: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { type: [Boolean, null], default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ k(["change"], ["update:modelValue"]),
  setup(t, { expose: C, emit: $ }) {
    var h;
    const a = t, V = L({ id: a.ouiaId, safe: a.ouiaSafe }), d = W(t, "modelValue"), I = $;
    E(z, (h = N()) == null ? void 0 : h.proxy);
    const u = P("inputRef"), p = R(() => a.labelWrapped && !a.component || a.component === "label");
    S(d, () => {
      u.value && (u.value.indeterminate = d.value === null);
    }, {
      immediate: !0
    });
    function q(e) {
      I("change", e), d.value = e.currentTarget.checked;
    }
    return C({
      input: u
    }), (e, K) => (r(), y(B(e.component ?? (p.value ? "label" : "div")), v(l(V), {
      class: [l(o).check, {
        [l(o).modifiers.standalone]: !e.labelWrapped && !(e.label || e.$slots.label)
      }],
      for: e.labelWrapped ? e.id : void 0
    }), {
      default: s(() => [
        g(M, null, {
          default: s(() => [
            g(A, {
              weight: e.labelBeforeButton ? -1 : 1
            }, {
              default: s(() => [
                e.label || e.$slots.label ? (r(), y(B(p.value ? "span" : "label"), {
                  key: 0,
                  class: n([l(o).checkLabel, {
                    [l(o).modifiers.disabled]: e.disabled
                  }]),
                  for: p.value ? void 0 : e.id
                }, {
                  default: s(() => [
                    c(e.$slots, "label", {}, () => [
                      f(b(e.label), 1)
                    ]),
                    e.required ? (r(), m("span", {
                      key: 0,
                      class: n(l(o).checkLabelRequired),
                      "aria-hidden": "true"
                    }, "*", 2)) : i("", !0)
                  ]),
                  _: 3
                }, 8, ["class", "for"])) : i("", !0)
              ]),
              _: 3
            }, 8, ["weight"]),
            T("input", v({
              id: e.id,
              ref: "inputRef"
            }, e.$attrs, {
              type: "checkbox",
              class: l(o).checkInput,
              checked: t.modelValue === null ? void 0 : t.modelValue,
              disabled: e.disabled,
              required: e.required,
              onChange: q
            }), null, 16, F)
          ]),
          _: 3
        }),
        e.description || e.$slots.description ? (r(), m("span", {
          key: 0,
          class: n(l(o).checkDescription)
        }, [
          c(e.$slots, "description", {}, () => [
            f(b(e.description), 1)
          ])
        ], 2)) : i("", !0),
        e.body || e.$slots.default ? (r(), m("span", {
          key: 1,
          class: n(l(o).checkBody)
        }, [
          c(e.$slots, "default", {}, () => [
            f(b(e.body), 1)
          ])
        ], 2)) : i("", !0)
      ]),
      _: 3
    }, 16, ["class", "for"]));
  }
});
export {
  X as default
};
